import React from 'react'
import './section_title.css'

const Add_section_title = ({ title, alltotal }) => {
  return (
    <>
      <div className='Add_section_title_div theme_bg'>
        <h6 className='sectitle'>{title}</h6>
        <h6 className='sectitle'>{alltotal}</h6>
      </div>
    </>
  )
}

export default Add_section_title